import React, { useState } from 'react';
import { IExerciseGroup } from '../../../types/workout/exercise-group';
import { ExerciseGroupType } from '../../../types/workout/group-type';
import { PD, SF, SFm } from './tokens';

interface GroupNavProps {
  groups: IExerciseGroup[];
  /** Called with the group index when the user clicks a chip. */
  onJump: (_groupIdx: number) => void;
  /** Index of the active group (highlighted chip). */
  activeIdx?: number;
}

function isRest(g: IExerciseGroup): boolean {
  return g.groupType === ExerciseGroupType.REST || g.isRestPeriod === true;
}

const GroupNav: React.FC<GroupNavProps> = ({ groups, onJump, activeIdx }) => {
  const [active, setActive] = useState<number>(activeIdx ?? 0);

  if (!groups || groups.length === 0) return null;

  return (
    <div
      className="pd-no-scrollbar"
      style={{
        padding: '10px 18px',
        borderBottom: `0.5px solid ${PD.hairline}`,
        background: PD.card,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        overflowX: 'auto',
        flex: '0 0 auto'
      }}
    >
      {groups.map((g, i) => {
        const on = i === active;
        const rest = isRest(g);
        const exCount = (g.exercises || []).length;
        const label = rest ? `Descanso ${g.restDuration ?? 0}s` : g.name || `Bloque ${i + 1}`;

        return (
          <button
            key={g.id ?? i}
            type="button"
            onClick={() => {
              setActive(i);
              onJump(i);
            }}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: '5px 10px 5px 6px',
              borderRadius: 999,
              background: on ? PD.cta : PD.fill,
              color: on ? PD.ctaFg : PD.ink2,
              border: 'none',
              cursor: 'pointer',
              fontFamily: SF,
              fontSize: 12,
              fontWeight: 600,
              whiteSpace: 'nowrap',
              flex: '0 0 auto'
            }}
          >
            <span
              style={{
                width: 18,
                height: 18,
                borderRadius: '50%',
                background: on ? 'rgba(255, 255, 255, 0.15)' : PD.card,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: SFm,
                fontSize: 10,
                fontWeight: 700,
                color: on ? PD.ctaFg : PD.ink2
              }}
            >
              {rest ? <i className="pi pi-moon" style={{ fontSize: 10 }} /> : i + 1}
            </span>
            {label}
            {!rest && exCount > 1 && (
              <span
                style={{
                  fontFamily: SFm,
                  fontSize: 10.5,
                  fontWeight: 600,
                  color: on ? 'rgba(255, 255, 255, 0.65)' : PD.ink3,
                  marginLeft: 1
                }}
              >
                · {exCount}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default GroupNav;
